module.exports = __webpack_public_path__ + "img/progressIcon.2acc02db.svg";